import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { smoothScroll } from '../../../lib/smooth-scroll';
import { TableOfContentItem } from '../table-of-contents/table-of-contents.component';

@Component({
  selector: 'app-table-of-contents-item-list',
  imports: [RouterLink],
  templateUrl: './table-of-contents-item-list.component.html',
  styleUrls: ['./table-of-contents-item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableOfContentsItemListComponent {
  @Input({ required: true }) items: TableOfContentItem[];
  @Input({ required: true }) level: number;

  smoothScroll(event: Event, id: string) {
    return smoothScroll(event, id);
  }
}
